var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLandUse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.25 47.5H33.75V51.25H36.25V47.5Z",
    fill: "url(#paint0_linear_180_6526)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.25 53.75H33.75V57.5H36.25V53.75Z",
    fill: "url(#paint1_linear_180_6526)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.25 60H33.75V63.75H36.25V60Z",
    fill: "url(#paint2_linear_180_6526)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.25 47.5H43.75V63.75H46.25V47.5Z",
    fill: "url(#paint3_linear_180_6526)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8749 28.75H14.3749V23.7C15.1624 23.625 15.9124 23.4 16.5624 23C17.2124 23.4 17.9624 23.625 18.7499 23.7V28.75H21.2499V23.7C22.0374 23.625 22.7999 23.3875 23.4499 22.9875C24.0999 23.375 24.8374 23.625 25.6249 23.6875V28.7375H28.1249V23.6875C29.4124 23.575 30.5874 23.025 31.4124 22.0875C32.2374 21.15 32.6124 19.9625 32.4624 18.7625C31.9499 14.6 30.3999 10.5 27.9874 6.9L27.9124 6.7875C27.4499 6.1 26.2999 6.1 25.8374 6.7875L25.7624 6.9C24.8624 8.2375 24.0874 9.65 23.4374 11.1C22.7999 9.6625 22.0374 8.25 21.1374 6.925L21.0624 6.8125C20.5999 6.0875 19.4124 6.0875 18.9499 6.8125L18.8999 6.9C17.9874 8.25 17.2249 9.675 16.5749 11.125C15.9249 9.675 15.1624 8.275 14.2624 6.9375L14.1874 6.825C13.7249 6.1 12.5374 6.1 12.0749 6.825L12.0249 6.9125C9.58744 10.5375 8.07494 14.525 7.54994 18.775C7.39994 19.9875 7.77494 21.1625 8.59994 22.1C9.42494 23.025 10.5999 23.575 11.8874 23.7V28.75H11.8749ZM23.7624 19.0875C24.1624 15.8375 25.2124 12.7375 26.8749 9.85C28.5374 12.7375 29.5874 15.8375 29.9874 19.0875C30.0499 19.575 29.8874 20.0625 29.5374 20.45C29.0874 20.9625 28.3999 21.25 27.6499 21.25H26.0999C25.3499 21.25 24.6624 20.9625 24.2124 20.45C23.8624 20.05 23.6999 19.575 23.7624 19.0875ZM17.7624 15.0375C18.2874 13.2625 19.0374 11.525 19.9999 9.8625C20.8999 11.425 21.6124 13.05 22.1249 14.7125C21.7374 16.05 21.4499 17.4125 21.2749 18.775C21.1749 19.5875 21.3249 20.375 21.6749 21.0875C21.3874 21.1875 21.0874 21.25 20.7624 21.25H19.2124C18.5249 21.25 17.8749 21 17.4249 20.5625C17.1749 20.325 16.7874 19.8 16.8749 19.0875C17.0374 17.7625 17.3249 16.4 17.7499 15.0375H17.7624ZM10.4624 20.45C10.1124 20.0625 9.96244 19.575 10.0124 19.0875C10.4124 15.8375 11.4624 12.7375 13.1249 9.8625C14.0249 11.425 14.7374 13.05 15.2624 14.725C14.8749 16.0875 14.5749 17.45 14.4124 18.775C14.3124 19.575 14.4749 20.375 14.8249 21.0875C14.5374 21.1875 14.2249 21.25 13.9124 21.25H12.3624C11.6124 21.25 10.9249 20.9625 10.4749 20.45H10.4624ZM72.4999 27.5V17.5C72.4999 16.8125 71.9374 16.25 71.2499 16.25H69.3749L65.9999 11.75C65.6749 11.325 65.1124 11.1375 64.5999 11.3125C64.0874 11.4875 63.7499 11.9625 63.7499 12.5V16.25H63.1249L59.7499 11.75C59.4249 11.325 58.8624 11.1375 58.3499 11.3125C57.8374 11.4875 57.4999 11.9625 57.4999 12.5V16.25H54.9999V10C54.9999 9.3125 54.4374 8.75 53.7499 8.75H48.7499C48.0624 8.75 47.4999 9.3125 47.4999 10V27.5C47.4999 28.1875 48.0624 28.75 48.7499 28.75H71.2499C71.9374 28.75 72.4999 28.1875 72.4999 27.5ZM69.9999 26.25H49.9999V11.25H52.4999V17.5C52.4999 18.1875 53.0624 18.75 53.7499 18.75H58.7499C59.4374 18.75 59.9999 18.1875 59.9999 17.5V16.25L61.4999 18.25C61.7374 18.5625 62.0999 18.75 62.4999 18.75H64.9999C65.6874 18.75 66.2499 18.1875 66.2499 17.5V16.25L67.7499 18.25C67.9874 18.5625 68.3499 18.75 68.7499 18.75H69.9999V26.25ZM59.9999 10H62.4999C62.4999 9.3125 63.0624 8.75 63.7499 8.75H68.7499V6.25H63.7499C61.6874 6.25 59.9999 7.9375 59.9999 10Z",
    fill: "url(#paint4_linear_180_6526)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 22.5H56.25V25H67.5V22.5Z",
    fill: "url(#paint5_linear_180_6526)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.875 57.5H59.375V61.25H61.875V57.5Z",
    fill: "url(#paint6_linear_180_6526)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.875 57.5H54.375V61.25H56.875V57.5Z",
    fill: "url(#paint7_linear_180_6526)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.875 63.75H59.375V67.5H61.875V63.75Z",
    fill: "url(#paint8_linear_180_6526)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.875 63.75H54.375V67.5H56.875V63.75Z",
    fill: "url(#paint9_linear_180_6526)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3625 52.325L30.65 50.1875L24.4 46.4375C24.0375 46.2125 23.575 46.2 23.2 46.3875L13.2 51.3875C12.775 51.6 12.5125 52.0375 12.5125 52.5V76.25H8.7625V78.75H71.25V76.25H67.5V55C67.5 54.5625 67.275 54.1625 66.9 53.9375L58.775 48.9375C58.425 48.7125 57.975 48.6875 57.6 48.8625L49.475 52.6125L50.525 54.8875L58.0375 51.4125L65 55.7V76.25H25V49.7125L29.3625 52.325ZM22.5 67.775L15 69.65V65.975L22.5 64.1V67.775ZM22.5 61.525L15 63.4V59.725L22.5 57.85V61.525ZM22.5 49.525V55.275L15 57.15V53.275L22.5 49.525ZM15 76.25V72.225L22.5 70.35V76.25H15ZM76.25 1.25H3.75C2.375 1.25 1.25 2.375 1.25 3.75V31.25C1.25 32.625 2.375 33.75 3.75 33.75H76.25C77.625 33.75 78.75 32.625 78.75 31.25V3.75C78.75 2.375 77.625 1.25 76.25 1.25ZM3.75 31.25V3.75H76.25V31.25H3.75Z",
    fill: "url(#paint10_linear_180_6526)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 5H38.75V8.75H41.25V5Z",
    fill: "url(#paint11_linear_180_6526)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 11.875H38.75V15.625H41.25V11.875Z",
    fill: "url(#paint12_linear_180_6526)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 19.375H38.75V23.125H41.25V19.375Z",
    fill: "url(#paint13_linear_180_6526)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.25 26.25H38.75V30H41.25V26.25Z",
    fill: "url(#paint14_linear_180_6526)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.25 43.7502V76.2502H48.75V44.7127C46.0625 43.9377 43.5625 42.7377 41.25 41.1752V66.3752C44.1 66.9627 46.25 69.4877 46.25 72.5002V76.2502H43.75V72.5002C43.75 70.4377 42.0625 68.7502 40 68.7502C37.9375 68.7502 36.25 70.4377 36.25 72.5002V76.2502H33.75V72.5002C33.75 69.4877 35.9 66.9627 38.75 66.3752V41.1752C36.4375 42.7377 33.9375 43.9377 31.25 44.7127V76.2502H28.75V43.7502C28.75 43.1752 29.1375 42.6752 29.7 42.5377C32.85 41.7502 35.775 40.3627 38.375 38.4127L39.25 37.7502C39.7 37.4127 40.3 37.4127 40.75 37.7502L41.625 38.4127C44.225 40.3627 47.15 41.7502 50.3 42.5377C50.8625 42.6752 51.25 43.1752 51.25 43.7502Z",
    fill: "url(#paint15_linear_180_6526)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_180_6526",
    x1: 33.75,
    y1: 49.375,
    x2: 36.25,
    y2: 49.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_180_6526",
    x1: 33.75,
    y1: 55.625,
    x2: 36.25,
    y2: 55.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_180_6526",
    x1: 33.75,
    y1: 61.875,
    x2: 36.25,
    y2: 61.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_180_6526",
    x1: 43.75,
    y1: 55.6251,
    x2: 46.25,
    y2: 55.6251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_180_6526",
    x1: 7.5179,
    y1: 17.5002,
    x2: 72.4999,
    y2: 17.5002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_180_6526",
    x1: 56.2501,
    y1: 23.75,
    x2: 67.5,
    y2: 23.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_180_6526",
    x1: 59.375,
    y1: 59.375,
    x2: 61.875,
    y2: 59.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_180_6526",
    x1: 54.375,
    y1: 59.375,
    x2: 56.875,
    y2: 59.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_180_6526",
    x1: 59.375,
    y1: 65.625,
    x2: 61.875,
    y2: 65.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_180_6526",
    x1: 54.375,
    y1: 65.625,
    x2: 56.875,
    y2: 65.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_180_6526",
    x1: 1.25038,
    y1: 40.0006,
    x2: 78.75,
    y2: 40.0006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_180_6526",
    x1: 38.75,
    y1: 6.87503,
    x2: 41.25,
    y2: 6.87503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_180_6526",
    x1: 38.75,
    y1: 13.75,
    x2: 41.25,
    y2: 13.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_180_6526",
    x1: 38.75,
    y1: 21.25,
    x2: 41.25,
    y2: 21.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_180_6526",
    x1: 38.75,
    y1: 28.125,
    x2: 41.25,
    y2: 28.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_180_6526",
    x1: 28.7501,
    y1: 56.8739,
    x2: 51.25,
    y2: 56.8739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandUse);
export default __webpack_public_path__ + "static/media/Land Use.882731fdfb57044fdfdf7f770c46263a.svg";
export { ForwardRef as ReactComponent };